import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';

import YourPendingSwapsPanel from '../Components/YourPendingSwapsPanel';
import CompletedSwapsPanel from '../Components/CompletedSwapsPanel';
import CreateSwapModal from '../Components/CreateSwapModal';

export const AccountPage = () => {
  const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);

  useEffect(() => {
    getWindowDimensions();
  }, []);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;

  const openSwapModal = () => {
    setIsSwapModalOpen(true);
  };
  const closeSwapModal = () => {
    setIsSwapModalOpen(false);
  };
  return (
    <>
      <AccountPageWrapper width={width}>
        <HeadingWrapper>
          <PageTitle>Your account</PageTitle>
          <SecondHeader>
            Click into a swap to manage it and view more details.
          </SecondHeader>
        </HeadingWrapper>
        <PanelWrapper>
          <YourPendingSwapsPanel createSwapModal={openSwapModal} />
          <CompletedSwapsPanel />
        </PanelWrapper>
      </AccountPageWrapper>
      <CreateSwapModal
        isModalOpen={isSwapModalOpen}
        closeModal={closeSwapModal}
      />
    </>
  );
};

export default AccountPage;

const AccountPageWrapper = styled.div`
  padding-top: 100px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
  background-color: #f1f8fc;
  height: 1600px;
  ${(props: WidthType) => {
    const setWidth = props.width - 250;
    const setWidthString = setWidth.toString() + 'px';
    return css`
      width: ${setWidthString};
    `;
  }}
  @media (max-width: 414px) {
    padding: 0;
    width: 100vw;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 1400px;
  }
`;

const HeadingWrapper = styled.div`
  margin-bottom: 60px;
  width: 1056px;
  @media (max-width: 414px) {
    width: 95vw;
    padding-left: 20px;
    padding-top: 40px;
  }
`;

const PageTitle = styled.h1`
  color: #100f10;
  font-family: 'Tiempos Headline';
  font-size: 38px;
  font-weight: 600;
  @media (max-width: 414px) {
    color: #0e0d0e;
    font-family: 'Tiempos Headline';
    font-size: 22px;
    font-weight: 600;
  }
`;

const SecondHeader = styled.span`
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  @media (max-width: 414px) {
    color: #100f10;
    font-family: 'Avenir Next';
    font-size: 15px;
    font-weight: 500;
  }
`;

const PanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 1056px;
  @media (max-width: 414px) {
    height: 1075px;
    width: 335px;
    flex-direction: column;
  }
`;

type WidthType = {
  width: number;
};
